(function () {
  'use strict';

  function extractSectionInnerHTML(sectionHtml, selector = '.shopify-section') {
    if (typeof sectionHtml !== 'string' || !sectionHtml) return null;
    const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    return doc.querySelector(selector)?.innerHTML || null;
  }

  function patchSectionTarget(target, sectionHtml, selector) {
    if (!target) return false;
    const innerHtml = extractSectionInnerHTML(sectionHtml, selector);
    if (innerHtml == null) return false;
    target.innerHTML = innerHtml;
    return true;
  }

  function getSectionHtml(sections, ...keys) {
    if (!sections || typeof sections !== 'object') return null;
    for (const key of keys) {
      if (typeof key !== 'string' || !key) continue;
      if (typeof sections[key] === 'string' && sections[key]) {
        return sections[key];
      }
    }
    return null;
  }

  function render(cartData, opts = {}) {
    if (!cartData?.sections) return false;
    const sections = cartData.sections || {};
    let applied = false;
    const itemCount = Number(cartData.item_count);

    const drawerInner = document.querySelector('#CartDrawer');
    if (drawerInner && sections['cart-drawer']) {
      applied = patchSectionTarget(drawerInner, sections['cart-drawer'], '#CartDrawer') || applied;
    }

    const iconBubble = document.getElementById('cart-icon-bubble');
    if (iconBubble && sections['cart-icon-bubble']) {
      applied = patchSectionTarget(iconBubble, sections['cart-icon-bubble'], '.shopify-section') || applied;
    }

    const mainCartItems = document.getElementById('main-cart-items');
    const mainCartItemsId = mainCartItems?.dataset?.id;
    const mainCartItemsHtml = getSectionHtml(sections, mainCartItemsId, 'main-cart-items');
    if (mainCartItems && mainCartItemsHtml) {
      const target = mainCartItems.querySelector('.js-contents') || mainCartItems;
      applied = patchSectionTarget(target, mainCartItemsHtml, '.js-contents') || applied;
      if (Number.isFinite(itemCount)) {
        mainCartItems.closest('cart-items')?.classList.toggle('is-empty', itemCount === 0);
      }
    }

    const mainCartFooter = document.getElementById('main-cart-footer');
    const mainCartFooterId = mainCartFooter?.dataset?.id;
    const mainCartFooterHtml = getSectionHtml(sections, mainCartFooterId, 'main-cart-footer');
    if (mainCartFooter && mainCartFooterHtml) {
      applied = patchSectionTarget(mainCartFooter, mainCartFooterHtml, '#main-cart-footer') || applied;
      if (Number.isFinite(itemCount)) {
        mainCartFooter.classList.toggle('is-empty', itemCount === 0);
      }
    }

    if (applied && typeof opts.afterRender === 'function') {
      opts.afterRender(cartData);
    }

    return applied;
  }

  window.drCartSectionsRenderer = {
    extractSectionInnerHTML,
    patchSectionTarget,
    getSectionHtml,
    render,
  };
})();
